export { default as RRPFootnote } from "./RRPFootnote";
